import { paymentContextInterceptor } from '@payments/app/core/interceptors/payment-context.interceptor';

/**
 * Portal PAY usa PAYMENT_ENV (environment.payment.url).
 * Bearer é aplicado pelo interceptor do módulo auth em todas as APIs.
 */
export const paymentsProviders = [] as const;

export const paymentsInterceptors = [paymentContextInterceptor] as const;
